export interface IPagination {
  pageindex: number;
  pagesize: number;
  pagecount: number;
  totalpage: number;
  total: number;
}
export class Pagination implements IPagination {
  pageindex: number;
  pagesize: number;
  pagecount: number;
  totalpage: number;
  total: number;
}